import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export interface AddCommentParams {
  rgSenderId: number;
  rgComment: string;
}

export interface AddCommentResponse {
  success: boolean;
  message?: string;
}

export function useAddComment() {
  return useMutation<AddCommentResponse, Error, AddCommentParams>({
    mutationFn: async (params: AddCommentParams) => {
      const response = await axios.post('/rg/comment', {
        rgSenderId: params.rgSenderId,
        rgComment: params.rgComment,
      });

      return response.data;
    },
  });
}
